import { LegalEntityDto, LegalEntityBaseInfoDto } from '@sr/dto';

export const formatLegalEntity = (legalEntity: LegalEntityDto | LegalEntityBaseInfoDto): string => {
  const { name, legalEntityType: { name: typeName } } = legalEntity;

  return `${name}, ${typeName}`;
};
